'use client';

import { c as _c } from "react/compiler-runtime";
import payoutInfo1 from '@/public/images/partner/icon_payout_info_1.svg';
import payoutInfo2 from '@/public/images/partner/icon_payout_info_2.svg';
import payoutInfo3 from '@/public/images/partner/icon_payout_info_3.svg';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
export default function PayoutInfoSection() {
  const $ = _c(47);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("partner.payout-info.feature1.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("partner.payout-info.feature1.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      icon: payoutInfo1,
      title: t0,
      description: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("partner.payout-info.feature2.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("partner.payout-info.feature2.description");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      icon: payoutInfo2,
      title: t3,
      description: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("partner.payout-info.feature3.title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("partner.payout-info.feature3.description");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      icon: payoutInfo3,
      title: t6,
      description: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t5, t8];
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const payoutFeatures = t9;
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 20
    };
    t11 = {
      opacity: 1,
      y: 0
    };
    t12 = {
      once: true,
      amount: 0.2
    };
    t13 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t10 = $[25];
    t11 = $[26];
    t12 = $[27];
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("partner.payout-info.title");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <motion.div initial={t10} whileInView={t11} viewport={t12} transition={t13}><h2 className="text-center text-[28px] leading-10 font-extrabold tracking-[0.15px] text-white md:text-[38px]">{t14}</h2></motion.div>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== payoutFeatures) {
    t16 = <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-3">{payoutFeatures.map(_temp)}</div>;
    $[33] = payoutFeatures;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      opacity: 0,
      y: 20
    };
    t18 = {
      opacity: 1,
      y: 0
    };
    t19 = {
      once: true,
      amount: 0.2
    };
    t20 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t17 = $[35];
    t18 = $[36];
    t19 = $[37];
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t) {
    t21 = t("partner.payout-info.footer-text");
    $[39] = t;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t21) {
    t22 = <motion.div initial={t17} whileInView={t18} viewport={t19} transition={t20}><p className="text-vive-primary-30 text-center text-xs leading-[18px] tracking-[0.2px] md:text-[14px] md:leading-[22px]">{t21}</p></motion.div>;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t15 || $[44] !== t16 || $[45] !== t22) {
    t23 = <section className="bg-background relative flex flex-col items-center px-4 py-12 md:px-8 md:py-20 lg:px-[72px] lg:py-[120px]"><div className="flex w-full max-w-[1296px] flex-col gap-12 md:gap-12">{t15}{t16}{t22}</div></section>;
    $[43] = t15;
    $[44] = t16;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
}
function _temp(feature, index) {
  return <motion.div key={feature.title} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.6,
    ease: "easeOut",
    delay: index * 0.12
  }} className="flex flex-col gap-3 rounded-3xl bg-linear-to-b from-[rgba(42,54,73,0.5)] to-[rgba(42,54,73,0.3)] p-4 md:p-6"><div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-linear-to-b from-[rgba(42,54,73,0.5)] to-[rgba(42,54,73,0.3)]"><feature.icon /></div><h3 className="text-sm leading-[22px] font-semibold tracking-[0.2px] text-white">{feature.title}</h3><p className="text-vive-primary-20 text-sm leading-[22px] tracking-[0.2px] md:text-base md:leading-6">{feature.description}</p></motion.div>;
}